import { Navigate, useLocation, useParams } from "react-router";
import { useCurrentUserApi } from "@/api/use-users-api";
import { useLandlordApi } from "@/api/use-landlord-api";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const { isLoading: isUserLoading, isError: isUserError } = useCurrentUserApi();
  const { landlordId } = useParams<{ landlordId: string }>();

  const { isLoading: isLandlordLoading, isError: isLandlordError } = useLandlordApi({
    landlordId: landlordId
  });

  const redirectToSignIn = <Navigate replace to={`/auth/sign-in?returnUrl=${location.pathname}`} />;

  // No token means the user is not authenticated (a 401 also clears it via the api-client
  // interceptor), so redirect immediately without waiting on the queries.
  if (!token) {
    return redirectToSignIn;
  }

  if (isUserLoading || isLandlordLoading) {
    return null;
  }

  // With a token present, a settled query error is treated as a genuine failure. The
  // landlord query retries first (see useLandlordApi), so transient errors on the first
  // authenticated request right after an OAuth full-page reload don't bounce the user.
  if (isUserError || isLandlordError) {
    return redirectToSignIn;
  }

  return <>{children}</>;
};
